// Source filter shared between Today, Inbox, etc. Persisted per-view in
// localStorage so a tab switch keeps the filter where it was.

import type { SurfaceTask } from "./types";

export type Filter = "all" | "vault" | "personal" | "work";

export function applyFilter(t: SurfaceTask, f: Filter): boolean {
  if (f === "all") return true;
  if (f === "personal") return t.account === "personal";
  if (f === "work") return t.account === "work";
  if (f === "vault") {
    return (
      !!t.project_slug &&
      !t.project_slug.startsWith("_") &&
      !t.fingerprint.startsWith("gt:")
    );
  }
  return true;
}

export function loadFilter(key: string): Filter {
  try {
    const v = localStorage.getItem(key);
    if (v === "all" || v === "vault" || v === "personal" || v === "work") return v;
  } catch {}
  return "all";
}

export function saveFilter(key: string, value: Filter) {
  try {
    localStorage.setItem(key, value);
  } catch {}
}
